import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogStopChargeStationView.propTypes = {
  item: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogStopChargeStationView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');
  const [operationalDate, setOperationalDate] = useState('');

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    const trimmedReason = _.trim(reason);
    if (_.isEmpty(trimmedReason)) {
      ToastHelper.showError('Vui lòng nhập lý do ngừng hoạt động');
      return;
    }

    let param = {
      reason: trimmedReason,
      operationalDate: operationalDate
        ? moment(operationalDate).format('YYYY-MM-DD')
        : null,
      status: ChargeConstants.ChargeStationStatus.STOPPED,
    };
    param = _.omitBy(param, (value) => _.isEmpty(value) || _.isNil(value));
    setLoading(true);
    const result = await ChargeHelper.API.requestUpdateChargeStation(item?.stationId, param);
    if (result && _.isBoolean(result)) {
      ToastHelper.showSuccess('Ngừng hoạt động trạm sạc thành công');
      if (onDone) {
        onDone();
      }
    } else {
      ToastHelper.showError(result || 'Ngừng hoạt động trạm sạc thất bại');
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 gap-3">
        <div className="">
          <img src={AppResource.images.dialogIcons.dialogStopAgency} />
        </div>

        <span style={UIHelper.buildFontStyle('600', '16px', undefined, AppColors.gray[800])}>
           Ngừng hoạt động
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', undefined, AppColors.gray[600])}>
          Việc ngừng hoạt động trạm sẽ dẫn đến toàn bộ tủ pin và ngăn pin trong trạm bị vô hiệu hóa, tài xế và khách hàng sẽ không thể thực hiện bất kỳ giao dịch đổi pin nào tại trạm này. Bạn vẫn muốn tiếp tục?
        </span>
      </div>

      <div className="row m-0 p-0 px-5">
        <div className="col-12 mb-3 px-0">
          <div>
            {UIHelper.buildFormLabel('Lý do', true)}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder="Nhập lý do"
              name="reason"
              value={reason}
              onChange={(value) => {
                setReason(value);
              }}
            />
          </div>
        </div>

        <div className="col-12 mb-3 px-0">
          <div>
            {UIHelper.buildFormLabel('Thời gian hoạt động trở lại')}
            <KTFormInput
              type={KTFormInputType.date}
              showTime
              placeholder="Chọn ngày và giờ"
              name="operationalDate"
              value={operationalDate}
              onChange={(value) => {
                setOperationalDate(value);
              }}
              minTime={moment().add(30, 'minutes').toISOString()}
            />
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center gap-3 p-5"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        <div className="w-50">
          {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        </div>
        <div className="w-50">
          {UIHelper.buildRedButton('Ngừng hoạt động', handleSubmit, null, false, loading)}
        </div>
      </div>
    </div>
  );
}

export default DialogStopChargeStationView;
